module.exports = __webpack_public_path__ + "img/tech02.18efadf1.jpg";